export const BUDDHIST_ERA_OFFSET = 543

export const THAI_MONTHS = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
] as const

export const THAI_MONTHS_SHORT = [
  'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.',
] as const

export const THAI_DAYS = [
  'อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์',
] as const

export function toBuddhistEra(gregorianYear: number): number {
  return gregorianYear + BUDDHIST_ERA_OFFSET
}

export function fromBuddhistEra(buddhistYear: number): number {
  return buddhistYear - BUDDHIST_ERA_OFFSET
}

export function getCurrentBuddhistYear(): number {
  return toBuddhistEra(new Date().getFullYear())
}

/** "วันจันทร์ที่ 15 สิงหาคม 2568" */
export function formatFullThaiDate(date: Date): string {
  const day = THAI_DAYS[date.getDay()]
  const d = date.getDate()
  const month = THAI_MONTHS[date.getMonth()]
  const year = toBuddhistEra(date.getFullYear())
  return `วัน${day}ที่ ${d} ${month} ${year}`
}

/** "15 ส.ค. 2568" */
export function formatShortThaiDate(date: Date): string {
  const d = date.getDate()
  const month = THAI_MONTHS_SHORT[date.getMonth()]
  const year = toBuddhistEra(date.getFullYear())
  return `${d} ${month} ${year}`
}

/** "15/08/2568" */
export function formatCompactThaiDate(date: Date): string {
  const d = String(date.getDate()).padStart(2, '0')
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const year = toBuddhistEra(date.getFullYear())
  return `${d}/${m}/${year}`
}

/** Academic year: starts May, ends April */
export function getCurrentAcademicYear(): number {
  const now = new Date()
  const year = toBuddhistEra(now.getFullYear())
  return now.getMonth() >= 4 ? year : year - 1
}

export function toISODateString(date: Date): string {
  return date.toISOString().split('T')[0]
}
